import { apiClient } from './apiClient';

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  role: 'CUSTOMER' | 'THERAPIST' | 'ADMIN';
  emailVerified: boolean;
  createdAt: string;
}

export interface UpdateProfileData {
  name?: string;
  phone?: string;
}

export const userApi = {
  /**
   * Get current user's profile
   */
  getProfile: async (): Promise<UserProfile> => {
    const response = await apiClient.get('/api/users/profile');
    const data = response.data;
    return data.data || data;
  },

  /**
   * Update current user's profile
   */
  updateProfile: async (profileData: UpdateProfileData): Promise<UserProfile> => {
    const response = await apiClient.patch('/api/users/profile', profileData);
    const data = response.data;
    return data.data || data;
  },
};
